import styled from 'styled-components'
import { Grid } from 'components/atoms'

export const Wrapper = styled(Grid)`
  padding-bottom: 30px;
`
